<template>
  <div>
    <BaseDialog
      v-model="showDialog"
      dialogIcon="mdi-alert"
      :title="title"
      btnActionName="Lagre"
      @action="save()"
    >
      <template v-slot>
        <v-form ref="actionFrom" v-model="validForm" lazy-validation>
          <v-text-field
            v-model="action.title"
            color="primary"
            label="Title"
            filled
            :rules="[(v) => !!v || 'Tittel må angis.']"
          ></v-text-field>
          <v-select
            v-model="action.actionsType"
            :items="actionsTypes"
            item-text="name"
            item-value="id"
            label="Type"
            hide-detail
            filled
            :rules="[(v) => !!v || 'Type må angis.']"
          ></v-select>
          <v-select
            v-model="action.severity"
            :items="actionSeverities"
            item-text="name"
            item-value="id"
            label="Alvorlighetsgrad"
            hide-detail
            filled
          ></v-select>
          <v-textarea
            v-model="action.description"
            color="primary"
            label="Beskrivelse"
            filled
            dense
            :rules="[(v) => !!v || 'Beskrivelse må angis.']"
          ></v-textarea>
          <div v-if="!isMobile">
            <DatePicker v-model="action.timeLimit" label="Frist" />
          </div>
          <div v-else>
            <!-- <v-dialog></v-dialog> -->
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              min-width="auto"
              full-width
              top
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="getFormattedDate"
                  label="Frist"
                  prepend-inner-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                  readonly
                  filled
                  hide-details
                >
                </v-text-field>
              </template>
              <v-date-picker
                v-model="action.timeLimit"
                :active-picker.sync="activePicker"
                scrollable
                show-current
                autoFocus="true"
                color="primary"
                header-color="date"
                :max="getSixYrsMax()"
                :min="getTwoYrsMin()"
                @change="saveTimeLimit"
              ></v-date-picker>
            </v-menu>
          </div>
          <!-- <div v-if="fullscreen()">
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              min-width="auto"
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="action.timeLimit"
                  label="Frist"
                  v-bind="attrs"
                  v-on="on"
                  readonly
                >
                </v-text-field>
              </template>
              <v-date-picker
                v-model="action.timeLimit"
                :active-picker.sync="activePicker"
                :min="
                  new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                    .toISOString()
                    .substr(0, 10)
                "
                @change="saveTimeLimit"
              ></v-date-picker>
            </v-menu>
          </div> -->
          <ContactPersonPicker
            v-model="action.responsibleId"
            label="Ansvarlig"
            prepend-inner-icon="mdi-account-sync"
            :rules="[(v) => !!v || 'Ansvarlig må angis.']"
          />
          <v-btn
            v-if="action.attachments && action.attachments.length > 0"
            class="mb-2"
            small
            color="primary"
            @click="$refs.dropzone.addAttachment()"
          >
            Legg til fil
          </v-btn>
          <FileDropzone
            ref="dropzone"
            v-model="action.attachments"
            :close="false"
          />
        </v-form>
      </template>
    </BaseDialog>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import BaseDialog from "@/components/shared/dialog/BaseDialog.vue";
import FileDropzone from "@/components/shared/attachments/FileDropzone.vue";
import ContactPersonPicker from "@/components/shared/field/ContactPersonPicker.vue";
import DatePicker from "@/components/shared/date/DatePickerDialog.vue";
import moment from "moment";

export default Vue.extend({
  name: "EditProfileDialog",
  data() {
    return {
      activePicker: null,
      menu: false,
      nowDate: new Date().toISOString().slice(0, 10),
    };
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    action: {
      type: Object,
      required: true,
      default: null,
    },
    title: {
      type: String,
      default: "Tiltak",
    },
    actionsTypes: {
      type: Array,
      required: true,
      default: null,
    },
    actionSeverities: {
      type: Array,
      required: true,
      default: null,
    },
    validForm: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    menu(value) {
      value && setTimeout(() => ((this as any).activePicker = "YEAR"));
    },
  },
  // mounted(){
  //   this.action.timeLimit = new Date().toISOString().slice(0, 10);
  // },
  methods: {
    save() {
      if ((this as any).$refs.actionFrom.validate()) {
        this.$emit("save");
        (this as any).showDialog = false;
      }
    },
    saveTimeLimit(date) {
      (this as any).$refs.menu.save(date);
    },
    getSixYrsMax() {
      let current = new Date();
      return new Date(current.setFullYear(current.getFullYear() + 6))
        .toISOString()
        .slice(0, 10);
    },
    getTwoYrsMin() {
      let current = new Date();
      return new Date(current.setFullYear(current.getFullYear() - 2))
        .toISOString()
        .slice(0, 10);
    },
  },
  computed: {
    showDialog: {
      get(): boolean {
        return (this as any).value;
      },
      set(value: boolean) {
        (this as any).$emit("input", value);
      },
    },
    getFormattedDate() {
      if ((this as any).action.timeLimit)
        return moment((this as any).action.timeLimit).format("DD.MM.YYYY");
      return (this as any).action.timeLimit;
    },
    isMobile() {
      return (this as any).$vuetify.breakpoint.mobile;
    },
  },
  components: {
    BaseDialog,
    ContactPersonPicker,
    FileDropzone,
    DatePicker,
  },
});
</script>
